
<!-- Newsletter: #Dark #Simple -->
<!-- <section class="p-20 w-full">
    <div class="mx-auto max-w-7xl">
        <div
            class="relative isolate overflow-hidden bg-gray-900 px-6 py-24 shadow-2xl rounded-2xl sm:rounded-3xl sm:px-24 xl:py-32">
            <h2 class="mx-auto max-w-2xl text-center text-3xl font-bold tracking-tight text-white sm:text-4xl">Never
                miss an
                offer</h2>
            <p class="mx-auto mt-2 max-w-xl text-center text-lg leading-8 text-gray-300">Subscribe and be the first to
                receive
                our exclusive offers.</p>
            <form class="mx-auto mt-10 flex max-w-md gap-x-4">
                <label for="email-address" class="sr-only">Email address</label>
                <input id="email-address" name="email" type="email" autocomplete="email" required=""
                    class="min-w-0 flex-auto rounded-md border-0 bg-white/5 px-3.5 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
                    placeholder="Enter your email">
                <button type="submit"
                    class="flex-none rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">Notify
                    me</button>
            </form>
        </div>
    </div>
</section> -->

<!-- Newsletter #Light #2Cols -->
<section class="w-full px-15">
    <div class="flex-col items-center justify-center mt-10">
        <div class="w-full flex justify-center items-center mb-10">
            <div class="w-full flex flex-row p-10 justify-between items-center">
                <div class="flex flex-col">
                     @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                        @case (1) {
                            <app-heading_section-type01 [options]="{heading:'News & Blog',title:'Book a Hotel Within Your Budget',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_section-type01>
                            }
                        @case (2) {
                            <app-heading_section-type01 [options]="{heading:'News & Blog',title:'Book a Hotel Within Your Budget',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                        }
                    }
                }
                </div>
            </div>
        </div>
    </div>
        <div class="grid grid-cols-1 md:grid-cols-2">
            <div id="news_left">
                <div class="w-full flex items-center justify-center">
                    <article class="h-[690px] max-w-lg w-full bg-white overflow-hidden dark:bg-gray-700">
                        <div>
                            <img class="object-cover h-90 w-full"
                                src="https://images.pexels.com/photos/7968580/pexels-photo-7968580.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                                alt="article image" />
                        </div>
                    
                        <div class="flex gap-1 mt-8 px-8">
                            <div class="flex items-center mr-4">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                <p class="text-md text-gray-800">By Alex Micheal</p>
                            </div>
                            <div class="flex items-center">
                                <mat-icon class="text-primary-500 mr-2" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                                <p class="text-md text-gray-800">Jun 15, 2023</p>
                            </div>
                        </div>
                        <div class="mt-8 px-8 mb-5">
                            <h3 class="text-3xl font-semibold font-primary mt-5">The Ultimate Guide to Traveling When You Have No Money</h3>
                            <p class="mt-3 text-gray-500">
                                Embark on a budget-friendly adventure is not just about saving money, It's about maximizing your experiences. By adopting a thrifty mindset, exploring alternative accommodations mastering
                            </p>
                        </div>
                        <hr class="ml-5 mr-5">
                        <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3 px-4">
                            <button class="group py-2 px-2 uppercase hover:text-primary-500 font-semibold">
                                <span class="group-hover:text-primary-500 transition ease-out duration-500"></span>Read More
                                <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                            </button>
                        </div>
                    </article>
                </div>
            </div>

            <div id="news_right" class="">
                <div class="w-full mx-auto bg-white overflow-hidden mb-10">
                    <article class="md:flex">
                        <div class="md:shrink-0">
                            <img class="h-48 object-cover md:h-full w-48" src="https://images.pexels.com/photos/4352151/pexels-photo-4352151.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1">
                        </div>
                        <div class="p-6">
                            <div class="flex gap-1">
                                <div class="flex items-center mr-4">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                    <p class="text-md text-gray-800">By Alex Micheal</p>
                                </div>
                                <div class="flex items-center">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                                    <p class="text-md text-gray-800">Jun 15, 2023</p>
                                </div>
                            </div>
                            <h3 class="text-xl font-semibold font-primary mt-5 mb-5">The Ultimate Guide to Traveling When You Have No Money</h3>
                            <hr class="h-1 bg-gray-300 border-0 rounded">
                            <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3">
                                <button class="group px-2 uppercase hover:text-primary-500 font-semibold">
                                    <span class="group-hover:text-primary-500 transition ease-out duration-500"></span>Read More
                                    <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="w-full mx-auto bg-white overflow-hidden mb-10">
                    <article class="md:flex">
                        <div class="md:shrink-0">
                            <img class="h-48 w-full object-cover md:h-full md:w-48" src="https://images.pexels.com/photos/2589010/pexels-photo-2589010.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1">
                        </div>
                        <div class="p-6">
                            <div class="flex gap-1">
                                <div class="flex items-center mr-4">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                    <p class="text-md text-gray-800">By Alex Micheal</p>
                                </div>
                                <div class="flex items-center">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                                    <p class="text-md text-gray-800">Jun 15, 2023</p>
                                </div>
                            </div>
                            <h3 class="text-xl font-semibold font-primary mt-5 mb-5">The Ultimate Guide to Traveling When You Have No Money</h3>
                            <hr class="h-1 bg-gray-300 border-0 rounded">
                            <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3">
                                <button class="group px-2 uppercase hover:text-primary-500 font-semibold">
                                    <span class="group-hover:text-primary-500 transition ease-out duration-500"></span>Read More
                                    <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </article>
                </div>
                <div class="w-full mx-auto bg-white overflow-hidden mb-10">
                    <article class="md:flex">
                        <div class="md:shrink-0">
                            <img class="h-48 w-full object-cover md:h-full md:w-48" src="https://images.pexels.com/photos/1882889/pexels-photo-1882889.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1">
                        </div>
                        <div class="p-6">
                            <div class="flex gap-1">
                                <div class="flex items-center mr-4">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_outline:person_outline'"></mat-icon>
                                    <p class="text-md text-gray-800">By Alex Micheal</p>
                                </div>
                                <div class="flex items-center">
                                    <mat-icon class="text-primary-500 mr-2" [svgIcon]="'heroicons_outline:calendar-days'"></mat-icon>
                                    <p class="text-md text-gray-800">Jun 15, 2023</p>
                                </div>
                            </div>
                            <h3 class="text-xl font-semibold font-primary mt-5 mb-5">The Ultimate Guide to Traveling When You Have No Money</h3>
                            <hr class="h-1 bg-gray-300 border-0 rounded">
                            <div class="w-full relative flex justify-start items-center flex-wrap gap-5 mt-3">
                                <button class="group px-2 uppercase hover:text-primary-500 font-semibold">
                                    <span class="group-hover:text-primary-500 transition ease-out duration-500"></span>Read More
                                    <mat-icon class="icon-size-5 text-black ml-2 pt-2 group-hover:text-primary-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </article>
                </div>
                
                
            </div>
            
        </div>
    
</section> 